// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"51329373","455":"4a39d710","977":"e30798f2"}[chunkId] + ".chunk.js";
};